import { Resources } from 'constants/resources';

import { usePermissions } from 'hooks/usePermissions';
import { useCreatePath } from 'react-admin';
import { Link } from 'react-router-dom';
import { Button, DeleteButton } from 'shared/mui/Buttons';
import { Permission } from 'types/embedded/permission';
import { Preset } from 'types/embedded/preset';

const TAB_CONFIG = {
  1: { label: 'Редактировать пресеты пополнения', path: 'payment_items' },
  2: { label: 'Редактировать пресеты выводов', path: 'payout_items' },
} as const;

type Props = {
  tab: number;
  record: Preset | undefined;
  onDelete: () => void;
  onEditGeneral: (record: Preset) => void;
};

export const PresetsShowActions: React.FC<Props> = ({ tab, record, onDelete, onEditGeneral }) => {
  const { hasResourcePermissions } = usePermissions();
  const createPath = useCreatePath();

  const editPath = record
    ? createPath({ resource: Resources.Presets, id: record.id, type: 'edit' })
    : '';

  if (tab === 0) {
    const canDelete = hasResourcePermissions(Resources.Presets, [
      Permission.Full,
      Permission.Delete,
    ]);
    const canEdit = hasResourcePermissions(Resources.Presets, [Permission.Full, Permission.Update]);

    return (
      <>
        {canDelete && <DeleteButton label="Удалить" onClick={onDelete} variant="outlined" />}
        {canEdit && record && (
          <Button
            label="Редактировать общую информацию"
            onClick={() => onEditGeneral(record)}
            variant="contained"
          />
        )}
      </>
    );
  }

  const config = TAB_CONFIG[tab as keyof typeof TAB_CONFIG];
  if (!config) {
    return null;
  }

  return hasResourcePermissions(Resources.Presets, [Permission.Full, Permission.Update]) ? (
    <Button
      component={Link}
      label={config.label}
      to={`${editPath}/${config.path}`}
      variant="contained"
    />
  ) : null;
};
